module.exports = __webpack_public_path__ + "static/media/16UNODC24.35cf6245.jpg";